import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '../authentications/authentication.service';

@Injectable()
export class CanCreateSubscriptionGuard implements CanActivate {
  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly router: Router
  ) {}

  canActivate(): Observable<boolean> {
    return this.authenticationService.currentUser$.pipe(
      take(1),
      map((user) => {
        if (!user || user.canCreateSubscription) {
          return true;
        }

        this.router.navigateByUrl('/').then();
        return false;
      })
    );
  }
}
